import {
  Box,
  Flex,
  Icon,
  Text,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { LoginContext } from "@context/loginContext";
import { OportunityContext } from "@context/oportunityContex";
import { UsuallyContext } from "@context/usuallyContex";
import React from "react";
import { BiChevronRight } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import type { IDashboardOportunidade } from "src/@types/Home";
import { IconHeadset } from "src/assets/iconHeadset";
import { IconInfo } from "src/assets/iconInfo";
import { IconSchedule } from "src/assets/iconSchedule";
import { theme } from "src/styles/theme";

type Props = {
  data: IDashboardOportunidade[];
};

const CustomResume: React.FC<Props> = React.memo(({ data }) => {
  const navigate = useNavigate();
  const { setPageSidebar } = React.useContext(LoginContext);
  const { setHashSalesSidebar } = React.useContext(UsuallyContext);
  const { setFaseMyOportunity, setFaseHomeFilter } =
    React.useContext(OportunityContext);
  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleRedirect = React.useCallback(
    (fase: string) => {
      navigate("/oportunidades/minhas-oportunidades");
      setPageSidebar("Minhas oportunidades");
      localStorage.setItem("@option", "Minhas oportunidades");
      setHashSalesSidebar("MyOportunityComponent");
      setFaseMyOportunity([fase]);
      setFaseHomeFilter([fase]);
    },
    [
      navigate,
      setPageSidebar,
      setHashSalesSidebar,
      setFaseMyOportunity,
      setFaseHomeFilter,
    ],
  );

  const handleIconFase = React.useCallback((fase: string) => {
    if (fase.includes("atendimento")) {
      return <IconHeadset width="22" height="22" />;
    }
    // else if (fase.includes("aprovadas")) {
    //   return <IconInfo width="22" height="22" />;
    // }
    else if (fase.includes("Cliente Ouro")) {
      return <IconInfo width="22" height="22" />;
    } else {
      return <IconSchedule width="22" height="22" />;
    }
  }, []);

  const memoizedData = React.useMemo(() => data || [], [data]);

  if (memoizedData.length < 1) {
    return (
      <Flex h={"calc(100% - 40px)"} justifyContent={"center"} align={"center"}>
        <Text
          w={"fit-content"}
          color={theme.text50}
          textAlign="center"
          fontSize={{ base: "sm", md: "md" }}
        >
          Não há oportunidades pendentes!
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      justifyContent={{ base: "flex-start", sm: "flex-start", md: "center" }}
      align={{ base: "flex-start", sm: "flex-start", md: "center" }}
      gap={{ base: 2, md: 4 }}
    >
      {memoizedData.map(({ fase, quantidade }, index) => (
        <VStack key={index} minW={{ base: "45%", md: "auto" }}>
          <Flex
            justifyContent={"center"}
            align={{ base: "flex-start", sm: "flex-start", md: "center" }}
            gap={"4px"}
          >
            <Box
              display={"flex"}
              w={"fit-content"}
              h={{ base: "28px", md: "30px" }}
              justifyContent={"center"}
              alignItems={"flex-end"}
            >
              {handleIconFase(fase)}
            </Box>
            <Text
              fontSize={{ base: "xl", sm: "2xl", md: "4xl" }}
              fontWeight="semibold"
              w={"fit-content"}
              color={
                fase?.includes("Atualize agora") ? theme.error : theme.text
              }
            >
              {quantidade}
            </Text>
          </Flex>

          <Flex
            justifyContent={{
              base: "flex-start",
              sm: "flex-start",
              md: "center",
            }}
            align={{ base: "flex-start", sm: "flex-start", md: "center" }}
            h={"fit-content"}
          >
            <Text
              fontSize={{ base: "2xs", sm: "xs", md: "12px" }}
              color={theme.text50}
              w={"fit-content"}
              cursor={"pointer"}
              textAlign={"center"}
              _hover={{
                color: fase?.includes("Atualize agora")
                  ? theme.error
                  : theme.primary,
                fontWeight: "medium",
              }}
              onClick={() => handleRedirect(fase)}
            >
              {fase?.includes("-") ? (
                <>
                  {fase?.split("-")[0]?.trim()} <br />
                  {fase?.split("-")[1]?.trim()}
                </>
              ) : (
                fase
              )}
            </Text>
            <Box
              fontSize={{ base: "22px", sm: "22px", md: "24px" }}
              w={"fit-content"}
              color={theme.text}
            >
              <BiChevronRight />
            </Box>
          </Flex>
        </VStack>
      ))}
    </Flex>
  );
});

export default CustomResume;
